// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f82139cb","453":"d0e90d76","455":"af63bd88"}[chunkId] + ".chunk.js";
};